import { Skeleton } from 'primereact/skeleton';
import React, { useState, useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import { Chart } from '../../components/chart/Chart';
import api from '../../service/api';

export const GraficoSistemaConstrutivo = (props) => {

    const [grafico, setGrafico] = useState(null);
    const [exibirDetalhes, setExibirDetalhes] = useState(false);
    const [sistemaClicado, setSistemaClicado] = useState(null);
    const [descricaoSistemaClicado, setDescricaoSistemaClicado] = useState(null);
    const [loading, setLoading] = useState(true);

    const detalhes = (evt, item) => {
        if (item.length > 0) {
            setSistemaClicado(grafico.Ids[item[0]._index]);
            setDescricaoSistemaClicado(grafico.labels[item[0]._index]);
            setExibirDetalhes(true);
        }
    };

    const lightOptions = {
        legend: {
            display: false,
            labels: {
                fontColor: '#495057'
            }
        },
        responsive: true,
        hover: {
            onHover: function(e) {
               var point = this.getElementAtEvent(e);
               if (point.length) e.target.style.cursor = 'pointer';
               else e.target.style.cursor = 'default';
            }
        },
        'onClick': detalhes

    };

    const darkOptions = {
        legend: {
            display: false,
            labels: {
                fontColor: '#ebedef'
            }
        },
        responsive: true
    };

    useEffect(() => {
        setLoading(true);
        api.get(`/sistemaconstrutivo/dataini/${props.dataIni}/datafim/${props.dataFim}/id/${props.idCliente}`)
            .then(res => {
                setGrafico(res.data);
                setLoading(false);
            });
    }, [props.dataIni, props.dataFim, props.idCliente]);

    if (exibirDetalhes) {
        return <Redirect push to={`/atividadessistemalist/${sistemaClicado}/${descricaoSistemaClicado}/${props.dataIni}/${props.dataFim}`} />
    }
    else {
        return (
            <>
                {!loading && (
                    <Chart type="horizontalBar" height="300" data={grafico} options={lightOptions} />
                )}
                {loading && (
                    <>
                        <div className="p-col-12 p-md-6 p-xl-12">
                            <Skeleton height="18rem" />
                        </div>
                    </>
                )}
            </>
        )
    }
}